export const contractTypes = [
  "heating",
  "electricity",
  "gvs",
  "gas",
  "coldWater",
  "mazut",
  "coal",
  "sewerageGvs",
  "sewerageHvs",
  "sewerageStormSewer",
  "sewerageSurfaceRunoff",
];
